import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import ClientLists from "./ClientLists";
import CompanyLists from "./CompanyLists";
import CreatorLists from "./CreatorLists";
import SuppliersList from "./SuppliersLists";
import WokerLists from "./WokerLists";

const tabs = [
  // { label: "Education Lists", value: "education_list" },
  { label: "companyLists", value: "company_list" },
  { label: "suppliersLists", value: "supplier_list" },
  { label: "workersLists", value: "worker_list" },
  { label: "clientLists", value: "client_list" },
  { label: "creatorLists", value: "creator_list" },
];

function AdminClients() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, client: tab }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"clients"}
            tabs={tabs}
            activeTab={activeTab.client}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {
            // activeTab.client === "education_list" ? (
            //   <EducationLists />
            // ) :
            activeTab.client === "company_list" ? (
              <CompanyLists />
            ) : activeTab.client === "supplier_list" ? (
              <SuppliersList />
            ) : activeTab.client === "worker_list" ? (
              <WokerLists />
            ) : activeTab.client === "client_list" ? (
              <ClientLists />
            ) : activeTab.client === "creator_list" ? (
              <CreatorLists />
            ) : null
          }
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default AdminClients;
